import React from "react";

import { FormInputComponent } from "../../../../shared/components/FormElements/GenericForm";

const VideoStandCardEdition = (props) => {
    return (
        <React.Fragment>
            <FormInputComponent
                fieldType="text"
                fieldName={`cards.${props.index}.firstTitle`}
                fieldDescription={"Primer Título"}
                fieldPlaceholder=""
            />
            <FormInputComponent
                fieldType="text"
                fieldName={`cards.${props.index}.secondTitle`}
                fieldDescription="Segundo Título"
                fieldPlaceholder=""
            />
            <FormInputComponent
                fieldType="text"
                fieldName={`cards.${props.index}.cardTextColor`}
                fieldDescription={
                    "Color de texto: El color de texto elegido aplica para la descripción y el segundo título en la card."
                }
                colorPicker={true}
                colorPickerHandler={() =>
                    props.showHexPickerHandler(
                        `values.cards.${props.index}.cardTextColor`,
                        `cards.${props.index}.cardTextColor`
                    )
                }
                fieldPlaceholder="#000000"
            />
            <FormInputComponent
                fieldType="text"
                fieldName={`cards.${props.index}.videoLink`}
                fieldDescription="Link de Youtube: A continuación deberá colocar solamente el código del video de YouTube. ej: https://www.youtube.com/watch?v=sCxnFS_VUhM. Deberá colocar sCxnFS_VUhM"
                fieldPlaceholder=""
            />
        </React.Fragment>
    );
};

export default VideoStandCardEdition;
